import {categoryCssClassMap, categoryLabelMap} from '../../cnf/config';
import { useTranslation } from 'react-i18next';

export function getThemeByCategoryId(number: number, filter?: { [key: string]: boolean }, x?: number, y?: number): string {
    const cssClass = categoryCssClassMap[number];

    let additionalClass = '';

    // Determine additional class based on x and y
    if (typeof x !== 'undefined' && typeof y !== 'undefined') {
        // Determine additional class based on x and y
        if (x < 50) {
            if (y > 50) {
                additionalClass = 'purple';
            } else {
                additionalClass = 'dark-purple';
            }
        } else {
            if (y > 50) {
                additionalClass = 'red';
            } else {
                additionalClass = 'orange';
            }
        }
    }


    if (cssClass) {
        let finalClass = cssClass;

        // Check if any of the filters that are not selected are contained in the cssClass
        for (const key in filter) {
            if (!filter[key] && cssClass.includes(key)) {
                finalClass += ' hidden';
            }
        }

        // Append the additional class
        finalClass += ` ${additionalClass}`;

        return finalClass.trim();
    }

    throw new Error(`No CSS class found for number: ${number}`);
}

export function getCategoryLabelById(number: number): string {
    const { t } = useTranslation();

    const label = categoryLabelMap[number];
    if (label) {
        return t(label);
    }

    throw new Error(`No label found for number: ${number}`);
}